import React from 'react'

import { stepStatuses } from '../../constants'

import {
  APPLY_SOLICITUDE_PATH,
  APPLY_NEEDS_PATH,
  APPLY_PEOPLE_PATH,
  APPLY_INFO_PATH
} from '../../../MainRoutes/constants'

import StepNav from '../../../../components/StepNav/StepNav'
import RouteStepNav from '../../../RouteStepNav/RouteStepNav'

function ProjectStepNav() {
  return (
    <StepNav>
      <RouteStepNav
        path={APPLY_SOLICITUDE_PATH}
        step={stepStatuses.SOLICITUDE}
      >
        ¿Qué necesitas?
      </RouteStepNav>
      <RouteStepNav
        path={APPLY_NEEDS_PATH}
        step={stepStatuses.NEEDS}
        disabled
      >
        ¿Para qué lo necesitas?
      </RouteStepNav>
      <RouteStepNav
        path={APPLY_PEOPLE_PATH}
        step={stepStatuses.PEOPLE}
      >
        Capital humano
      </RouteStepNav>
      <RouteStepNav
        path={APPLY_INFO_PATH}
        step={stepStatuses.INFO}
      >
        Otros
      </RouteStepNav>
    </StepNav>
  )
}

export default ProjectStepNav
